import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './components/ToastProvider';
import ProtectedRoute from './components/ProtectedRoute';
import PortalLayout from './components/layout/PortalLayout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import MyGymPage from './pages/MyGymPage';
import PricingSlotsPage from './pages/PricingSlotsPage';
import ListingPreviewPage from './pages/ListingPreviewPage';
import ReviewsPage from './pages/ReviewsPage';
import BookingsPage from './pages/BookingsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import PaymentsSubscriptionsPage from './pages/PaymentsSubscriptionsPage';
import ProfilePage from './pages/ProfilePage';
import NotificationsPage from './pages/NotificationsPage';
import SupportPage from './pages/SupportPage';

function Protected({ children }) {
  return <ProtectedRoute><PortalLayout>{children}</PortalLayout></ProtectedRoute>;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/" element={<Protected><DashboardPage /></Protected>} />
              <Route path="/my-gym" element={<Protected><MyGymPage /></Protected>} />
              <Route path="/pricing-slots" element={<Protected><PricingSlotsPage /></Protected>} />
              <Route path="/listing-preview" element={<Protected><ListingPreviewPage /></Protected>} />
              <Route path="/reviews" element={<Protected><ReviewsPage /></Protected>} />
              <Route path="/bookings" element={<Protected><BookingsPage /></Protected>} />
              <Route path="/analytics" element={<Protected><AnalyticsPage /></Protected>} />
              <Route path="/payments" element={<Protected><PaymentsSubscriptionsPage /></Protected>} />
              <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
              <Route path="/notifications" element={<Protected><NotificationsPage /></Protected>} />
              <Route path="/support" element={<Protected><SupportPage /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
